import { Component, OnInit } from '@angular/core';
import { CompaniesService } from 'src/app/domains/companies/services';
import { Company, CompanyFilters } from 'src/app/domains/companies/models';
import { CompaniesResponse } from 'src/app/domains/companies/models/companies.model';
import { CompaniesFacade } from 'src/app/domains/companies/store/facade';

const PAGE_SIZE = 20;

@Component({
  selector: 'gdp-companies-main',
  templateUrl: './companies-main.component.html',
  styleUrls: ['./companies-main.component.scss']
})
export class CompaniesMainComponent implements OnInit {
  filters: CompanyFilters;
  companies: Company[] | null = null;
  loading = false;
  public pageSize: number;
  public page: number = 0;
  public sameFilters: boolean = true;
  public pagination = {
    page: 0,
    empty: true,
    totalPages: 0
  };

  constructor(
    private companiesService: CompaniesService,
    private facade: CompaniesFacade
  ) {
    this.filters = {
      name: '',
      id: '',
      alphaname: '',
      email: '',
      did: '',
      billingId: ''
    }
  }

  ngOnInit() {
    this.pageSize = PAGE_SIZE;
    this.facade.filters$.subscribe((data: CompanyFilters) => {
      this.filters = { ...data };
    });
  }

  public fetchCompanies() {
    this.companies = [];
    this.loading = true;
    if (this.filters && !this.sameFilters) {
      this.pagination.page = 0;
    } else {
      this.pagination.page = this.pagination.page;
    }
    this.sameFilters = true;
    this.companiesService.getCompaniesByFilters(this.pagination.page, this.pageSize, this.filters).subscribe(
      (response: CompaniesResponse) => {
        this.loading = false;
        this.companies = response.content.reverse();
        this.companies.length !== 0 ? this.pagination.totalPages = response.totalPages : this.pagination.totalPages = 1;
      }, () => {
        this.loading = false;
      });
  }

  filterChanged(event: CompanyFilters) {
    if (this.areNotEmptyFilters(event)) {
      this.filters = event;
    } else {
      this.filters = null;
    }
    this.sameFilters = false;
    this.fetchCompanies();
    this.facade.SetFilters(event);
  }

  areNotEmptyFilters(event) {
    return event.name !== '' ||
      event.alphaname !== '' ||
      event.id !== '' ||
      event.email !== '' ||
      event.dids !== '' ||
      event.billingId !== ''
  }

  selectPageSize(event) {
    this.pageSize = event;
    this.pagination.page = 0;
    this.fetchCompanies();
  }

  changeCurrentPage(event) {
    this.pagination = {
      page: event,
      empty: this.companies.length === 0,
      totalPages: this.pagination.totalPages
    }
    this.fetchCompanies();
  }
}
